export interface ICenterToCenterDistance {
    donorCenterId: number,
    recipientCenterId: number,
    distanceBetweenCenters: number
}